/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["полн.","напл.","наутро","претпл.","попл.","навечер","ноќе"],["полноќ","напладне","наутро","претпладне","попладне","навечер","ноќе"],u],[["полноќ","пладне","утро","претпл.","попл.","вечер","ноќ"],u,["полноќ","пладне","утро","претпладне","попладне","вечер","ноќ"]],["00:00","12:00",["04:00","10:00"],["10:00","12:00"],["12:00","18:00"],["18:00","24:00"],["00:00","04:00"]]];
